import StationsTable from '@/components/station/StationsTable';
import VisitorsTable from '@/components/station/VisitorsTable';
import { cn } from '@/lib/utils';
import { useAuthenticated } from '@gettactic/hooks';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from '@v2/components/ui/tabs';

export type AdminVisitorsIndexProps = {
  isRedesign?: boolean;
  officeId?: string | null;
}

const tabsOriginal: {
  id: string;
  title: string;
  render: ({isRedesign, officeId}: AdminVisitorsIndexProps) => JSX.Element;
}[] = [
  {
    id: 'stations',
    title: 'Stations',
    render: ({isRedesign, officeId}: AdminVisitorsIndexProps) => <StationsTable isRedesign={isRedesign} officeId={officeId} />
  },
  {
    id: 'invitations',
    title: 'Invitations',
    render: ({isRedesign, officeId}: AdminVisitorsIndexProps) => <VisitorsTable type="invitations" isRedesign={isRedesign} officeId={officeId} />
  },
  {
    id: 'visits',
    title: 'Visits',
    render: ({isRedesign, officeId}: AdminVisitorsIndexProps) => <VisitorsTable type="visits" isRedesign={isRedesign} officeId={officeId} />
  }
];
export function AdminVisitorsIndex({ isRedesign = false, officeId = null }: { isRedesign?: boolean, officeId?: string | null }) {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const tabs = tabsOriginal.filter(
    (x) => x.id !== 'stations' || authenticatedUser.permissions.settings
  );

  return (
    <div className={cn(isRedesign ? "w-full mt-0" : "mt-4")}>
      {isRedesign ? tabs[1].render({
        isRedesign: true,
        officeId: officeId
      }) : <div className={cn("my-4", isRedesign ? "mt-0" : "mt-4")}>
        <h4 className="text-2xl font-medium text-secondary [.tactic-v2_&]:text-secondary-foreground">
          Visitors
        </h4>
        <p className="pt-2 font-light text-secondary [.tactic-v2_&]:text-secondary-foreground">
          Manage office stations, visitors, and invitations.
        </p>
      </div>}
      {isRedesign ? null : (
        <Tabs defaultValue={tabs[0].id}>
          <TabsList>
            {tabs.map((tabDef) => (
              <TabsTrigger value={tabDef.id} key={tabDef.id} variant="minimalistic">
                {tabDef.title}
              </TabsTrigger>
            ))}
          </TabsList>

          {tabs.map((tabDef) => (
            <TabsContent key={tabDef.id} value={tabDef.id}>
              {tabDef.render({ isRedesign, officeId })}
            </TabsContent>
          ))}
        </Tabs>
      )}
    </div>
  );
}
